import React, {useContext} from "react";
import Aux from "../HOC/Aux";
import defaultImg from "../../images/room-1.jpeg"; //setting a default image
import {Link} from "react-router-dom";
import {FaShoppingCart, FaHeart} from "react-icons/fa";
import PropTypes from "prop-types";
import {RoomContext} from "../../Context";

const Room = (props)=>{ 
    let context  = useContext(RoomContext);                    
    const {name, slug, images, price, id} = props.roomObj;
    const {addToCart, items} = context;
    let currentEl;

    items.find((item,i) => { //extracts the current index
        currentEl = items[i];
        return item.id === id;
    });

    return(
        <Aux>
            <section className="room">
                <div className="room-img-container">
                    <div className="fav-room-outline"></div>
                    <img src={images[0] || defaultImg} alt={name}/>
                    <div className="price-top">
                        <h6>${price}</h6>
                        <p>Per night</p>
                    </div>
                    <Link smooth="true" to={`/rooms/${slug}#top`} className="btn-primary stylish-btn room-link"> Features </Link>
                    <div className="room-upper-btns">
                        <FaShoppingCart style={{color: currentEl.reserved ? "blue" : "#fff"}} className="shoppingCart mr-2" onClick={()=>addToCart("cartRooms", id)}/>
                        <FaHeart style={{color: currentEl.liked ? "red": "#fff", transition: "all 0.3s linear"}} className="favHeart" onClick={()=>addToCart("favRooms", id)}/>
                    </div>
                </div>
                <h5 className="room-title">{name}</h5>
            </section>
        </Aux>
    )
}

// settings up propTypes
Room.propTypes={
    roomObj: PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        images: PropTypes.arrayOf(PropTypes.string).isRequired,
        price: PropTypes.number.isRequired,
    })
}

export default Room;